// extracted by mini-css-extract-plugin
export var labelWrapper = "_g8-0";